module.exports = __webpack_public_path__ + "img/shakira.d153e648.jpg";